export default "__VITE_ASSET__cJkvMUsH__"